import React from "react";
import styled from 'styled-components';

const Container = styled.div`
    margin:auto;
    width: 95%;
    @media (min-width: 769px) {width:80%}  //RWD適應寬度
`;

export default Container;